// // import React, { useState, useEffect  } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import logo from '../Assets/Img/loginLogo.png'; // Replace with your actual logo path

// // const Login = () => {
// //   const [pin, setPin] = useState('');
// //   const [errorMessage, setErrorMessage] = useState('');
// //   const navigate = useNavigate();

// //    // ✅ Redirect if already logged in
// //    useEffect(() => {
// //     const isAuthenticated = sessionStorage.getItem('auth') === 'true';
// //     if (isAuthenticated) {
// //       navigate('/', { replace: true });
// //     }
// //   }, [navigate])

// //   const handleLogin = (e) => {
// //     e.preventDefault();
// //     if (pin === 'Yogesh1021') {
// //       sessionStorage.setItem('auth', 'true');
// //        navigate('/', { replace: true }); // ✅ replaces history
// //     } else {
// //       setErrorMessage('Incorrect PIN. Try again.');
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-gray-100 to-blue-200 flex items-center justify-center">
// //       <div className="bg-white shadow-xl rounded-xl p-8 w-full max-w-md text-center">
// //         <img
// //           src={logo}
// //           alt="Login Logo"
// //           className="mx-auto mb-2 w-16 h-16 rounded-full object-cover border border-gray-300"
// //         />
// //         {/* <h2 className="text-2xl font-semibold mb-2 text-gray-800">Welcome</h2> */}
// //         <p className="text-gray-500 mb-6">Enter the access PIN to continue</p>
// //         <form onSubmit={handleLogin} className="space-y-4">
// //           <input
// //             type="password"
// //             placeholder="Enter PIN"
// //             value={pin}
// //             onChange={(e) => setPin(e.target.value)}
// //             required
// //             className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
// //           />
// //           {errorMessage && (
// //             <p className="text-sm text-red-600">{errorMessage}</p>
// //           )}
// //           <button
// //             type="submit"
// //             className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
// //           >
// //             Login
// //           </button>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import logo from '../Assets/Img/Gold-logo.png';

// const Login = () => {
//   const [pin, setPin] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [capsWarning, setCapsWarning] = useState(false);
//   const navigate = useNavigate();

//   // ✅ Redirect if already logged in
//   useEffect(() => {
//     const isAuthenticated = sessionStorage.getItem('auth') === 'true';
//     if (isAuthenticated) {
//       navigate('/', { replace: true });
//     }
//   }, [navigate]);

//   // ✅ Handle Login (case-sensitive)
//   const handleLogin = (e) => {
//     e.preventDefault();
//     if (pin === 'FBIMIS@2025') {
//       sessionStorage.setItem('auth', 'true');
//       navigate('/home', { replace: true });
//     } else {
//       setErrorMessage('Incorrect PIN. Try again.');
//     }
//   };

//   // ✅ Detect Caps Lock
//   const handleKeyPress = (e) => {
//     const isCapsLock = e.getModifierState && e.getModifierState('CapsLock');
//     setCapsWarning(isCapsLock);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-100 to-blue-200 flex items-center justify-center">
//       <div className="bg-white shadow-xl rounded-xl p-8 w-full max-w-md text-center m-5">
//         <img
//           src={logo}
//           alt="Login Logo"
//           className="mx-auto mb-2 w-16 h-16 rounded-full object-cover border border-gray-300"
//         />
//         <p className="text-gray-500 mb-6">Enter the access PIN to continue</p>
//         <form onSubmit={handleLogin} className="space-y-4">
//           <input
//             type="password"
//             placeholder="Enter PIN"
//             value={pin}
//             onChange={(e) => setPin(e.target.value)}
//             onKeyUp={handleKeyPress}
//             required
//             className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//           {capsWarning && (
//             <p className="text-sm text-red-600 font-medium">
//               ⚠ Caps Lock is ON
//             </p>
//           )}
//           {errorMessage && (
//             <p className="text-sm text-red-600">{errorMessage}</p>
//           )}
//           <button
//             type="submit"
//             className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import logo from '../Assets/Img/Gold-logo.png';

const Login = () => {
  const [pin, setPin] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [capsWarning, setCapsWarning] = useState(false);
  const navigate = useNavigate();

  const { accounts } = useMsal();
  const user = accounts[0]; // Microsoft signed-in user

  // Redirect if already logged in
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('auth') === 'true';
    if (isAuthenticated) {
      navigate('/home', { replace: true });
    }
  }, [navigate]);

  // Handle login with hardcoded PIN
  const handleLogin = (e) => {
    e.preventDefault();
    if (pin === 'FBIMIS@2025') {
      sessionStorage.setItem('auth', 'true');
      navigate('/home', { replace: true });
    } else {
      setErrorMessage('Incorrect PIN. Try again.');
    }
  };

  // Detect Caps Lock
  const handleKeyPress = (e) => {
    const isCapsLock = e.getModifierState && e.getModifierState('CapsLock');
    setCapsWarning(isCapsLock);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-blue-200 flex items-center justify-center">
      <div className="bg-white shadow-xl rounded-xl p-8 w-full max-w-md text-center m-5">
        <img
          src={logo}
          alt="Login Logo"
          className="mx-auto mb-2 w-16 h-16 rounded-full object-cover border border-gray-300"
        />

        {user && (
          <p className="text-gray-700 mb-2 text-sm">
            Logged in as <strong>{user.name}</strong><br />
            <span className="text-xs text-gray-500">{user.username}</span>
          </p>
        )}

        <p className="text-gray-500 mb-6">Enter the access PIN to continue</p>

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="password"
            placeholder="Enter PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            onKeyUp={handleKeyPress}
            required
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {capsWarning && (
            <p className="text-sm text-red-600 font-medium">
              ⚠ Caps Lock is ON
            </p>
          )}

          {errorMessage && (
            <p className="text-sm text-red-600">{errorMessage}</p>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
